import React, { useState } from 'react';
import { Icon, Select, Tooltip } from 'antd';

import Grid from '@material-ui/core/Grid';
import { Button, DatePicker, Dropdown, Menu } from 'antd';
import TextEvents from 'app/components/TextEvents';
import WorkCycleTableContainer from 'app/containers/WorkCycleTableContainer';
import { styles, useStyles } from './WorkCycleFormStyles';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWorkCycle, clearWorkCycle } from 'app/actions/WorkCycleActions';
import ApiService from 'app/services/ApiService';
import { employeeById } from 'app/reducers';
import moment from 'moment';

const { Option } = Select;

const SelectItem = (name = [], value) => {
    let x = name[value]
    // x = name.map(i => i[value]);
    return typeof x !== 'undefined' && x !== null ? x.map((c, i) => <Option key={i}>{c}</Option>) : (x === null ? <Option disabled key={'cargando valores'}>No existen valores..</Option> : <Option key={'cargando'}>Cargando valores..</Option>);

}
export default function WorkCycleForm(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [id, setId] = useState([]);
    const [subdirec, setSubdirect] = useState([]);     //Coment line
    const employeeData = useSelector(employeeById);
    const { siteId } = useSelector(state => state.Auth);

    const [name, setName] = useState([]);
    let [courseFolio, setCourseFolio] = useState([]);
    const [desc, setDesc] = useState([]);
    let [status, setStatus] = useState([]);
    let [subdirList, setSubdirList] = useState();
    const [initialCreationDate, setInitialCreationDate] = useState('');
    const [finalCreationDate, setFinalCreationDate] = useState('');
    const [initialRevDate, setInitialRevDate] = useState('');
    const [finalRevDate, setFinalRevDate] = useState('');
    const [collapse, setCollapse] = useState(true);
    const data = {
        TestFolio: id.toString(),
        CourseFolio: courseFolio,
        TestTitle: name.length > 0 ? name[0].join("|") : '',
        TestDescription: desc,
        Subdirection: [employeeData.idSubdirection],//subdirec,
        InitialCreationDate: initialCreationDate,
        FinalCreationDate: finalCreationDate,
        InitialRevDate: initialRevDate,
        FinalRevDate: finalRevDate,
        ListStatus: status,
        Offset: 0
    }

    const search = () => {
        dispatch(clearWorkCycle());
        dispatch(fetchWorkCycle(data));
        props.setFormData(data);
    }

    const handleChange = (value, i, key) => {
        const array = [];
        i.map(i => {
            array.push(i.props.children);
            return array;
        })
        if (i.length === 0) {
            switch (key) {
                case 'testFolio':
                    setId([])
                    break;
                case 'courseFolio':
                    setCourseFolio([])
                    break;
                case 'subdirectionName':
                    setSubdirect([])
                    break;
                case 'testTitle':
                    setName([])
                    break;
                case 'testDescription':
                    setDesc([])
                    break;
                case 'statusName':
                    setStatus([])
                    break;
                default:
                    break;
            }
        }
        i.forEach(item => {
            if (key === 'testFolio') {
                setId([array]);
            } else if (key === 'courseFolio') {
                setCourseFolio([array]);
            } else if (key === 'subdirectionName') {
                let newsubdirList = [];
                array.forEach(i => {
                    subdirList.forEach(ids => {
                        if (ids.subdirectionName === i) {
                            const res = ids['idSubdirection'];
                            newsubdirList.push(res);
                        }
                    })
                })
                setSubdirect([newsubdirList])
            } else if (key === 'statusName') {
                setStatus([array])
            } else if (key === 'testTitle') {
                setName([array])
            } else if (key === 'testDescription') {
                setDesc([array])
            }
        })
    }

    const downloadTemplate = async () => {
        let param = {
            fileName: 'LayoutCicloTrabajo.xlsx',
        }

        await ApiService.getTestWorkCycleTemplate(param).then(
            result => {
                const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                downloadFile(blob, `${param.fileName}`);
            }
        ).catch(
            (error) => {
                // eslint-disable-next-line no-throw-literal
                throw ({ error: error, message: 'An error ocurred' });
            }
        )

    }

    const toExport = async () => {
        await ApiService.getWorkCycleExportToExcel(data)
            .then(
                result => {
                    const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    downloadFile(blob, "BandejaCiclosTrabajo.xlsx");
                },
                error => {
                    // eslint-disable-next-line no-throw-literal
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    }

    const disabledCStartDate = (current) => {
        if (finalCreationDate === "") {
            return false;
        } else {
            if (moment(current.format('YYYY-MM-DD')) > moment(finalCreationDate)) {
                return true;
            } else return false;
        }
    }
    const disabledCEndDate = (current) => {
        if (initialCreationDate === "") {
            return false;
        } else {
            if (moment(current.format('YYYY-MM-DD')) < moment(initialCreationDate)) {
                return true;
            } else return false;
        }
    }

    const disabledMStartDate = (current) => {
        if (finalRevDate === "") {
            return false;
        } else {
            if (moment(current.format('YYYY-MM-DD')) > moment(finalRevDate)) {
                return true;
            } else return false;
        }
    }
    const disabledMEndDate = (current) => {
        if (initialRevDate === "") {
            return false;
        } else {
            if (moment(current.format('YYYY-MM-DD')) < moment(initialRevDate)) {
                return true;
            } else return false;
        }
    }

    const downloadFile = (blob, fileName) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.append(link);
        link.click();
        link.remove();
        window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
    }


    function handleMenuClick(e) {
        switch (e.key) {
            case '1':
                props.setTab("2");
                break;
            case '2':
                break;
        }
    }

    const menu = (
        <Menu onClick={handleMenuClick}>
            <Menu.Item key="1">
                Evaluacion
            </Menu.Item>
            <Menu.Item key="2">
                Carga Masiva
            </Menu.Item>
        </Menu>
    );

    return (
        <div>
            <WorkCycleTableContainer>
                {(params) => {
                    return (
                        <div>
                            <div hidden={collapse}>
                                <Grid container direction="row">
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Folio'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={styles.inputSelect}
                                            placeholder="Selecciona folio"
                                            onChange={(v, i) => handleChange(v, i, 'testFolio')}
                                        >
                                            {SelectItem(params.workCycleFilter[0], 'folio')}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Nombre'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={{ ...styles.fullWidth }}
                                            placeholder="Selecciona nombre"
                                            onChange={(v, i) => handleChange(v, i, 'testTitle')}
                                        >
                                            {SelectItem(params.workCycleFilter[0], 'title')}
                                        </Select>
                                    </Grid>
                                </Grid>

                                <Grid container direction="row">
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Estatus'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={{ ...styles.inputSelect }}
                                            placeholder="Selecciona estatus"
                                            onChange={(v, i) => handleChange(v, i, 'statusName')}
                                        >
                                            {SelectItem(params.workCycleFilter[0], 'statusName')}
                                        </Select>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Folio de Procedimiento'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                            placeholder="Selecciona folio procedimiento"
                                            onChange={(v, i) => handleChange(v, i, 'courseFolio')}
                                        >
                                            {SelectItem(params.workCycleFilter[0], 'courseFolio')}
                                        </Select>
                                    </Grid>
                                </Grid>


                                <Grid container spacing={2} direction="row">
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Fecha de Creación'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Grid container spacing={2} direction="row">
                                            <Grid item xs={6}>
                                                <DatePicker
                                                    disabledDate={disabledCStartDate}
                                                    style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                    placeholder='Selecciona Fecha Inicial'
                                                    format={'DD/MM/YYYY'}
                                                    onChange={(date, dateString) => {
                                                        setInitialCreationDate(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                                                    }}

                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <DatePicker
                                                    disabledDate={disabledCEndDate}
                                                    style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                    placeholder='Selecciona Fecha Final'
                                                    format={'DD/MM/YYYY'}
                                                    onChange={(date, dateString) => {
                                                        setFinalCreationDate(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                                                    }}

                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Fecha de Modificación'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Grid container spacing={2} direction="row">
                                            <Grid item xs={6}>
                                                <DatePicker
                                                    disabledDate={disabledMStartDate}
                                                    style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                    placeholder='Selecciona Fecha Inicial'
                                                    format={'DD/MM/YYYY'}
                                                    onChange={(date, dateString) => {
                                                        setInitialRevDate(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                                                    }}

                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <DatePicker
                                                    disabledDate={disabledMEndDate}
                                                    style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                    placeholder='Selecciona Fecha Final'
                                                    format={'DD/MM/YYYY'}
                                                    onChange={(date, dateString) => {
                                                        setFinalRevDate(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                                                    }}

                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </div>
                            <div className={classes.container} style={styles.baseVerticalMargin}>
                                {
                                    collapse ?
                                        <Tooltip title={"Mostrar filtro"}>
                                            <Button
                                                className={classes.button}
                                                variant="contained"
                                                type="link"
                                                onClick={() => setCollapse(false)}
                                            >
                                                <Icon type="down" />
                                            </Button>
                                        </Tooltip> :
                                        <Tooltip title={"Ocultar filtro"}>
                                            <Button
                                                className={classes.button}
                                                variant="contained"
                                                type="link"
                                                onClick={() => setCollapse(true)}
                                            >
                                                <Icon type="up" />
                                            </Button>
                                        </Tooltip>
                                }
                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    type="primary"
                                    onClick={() => search()}
                                >
                                    Buscar
                                </Button>
                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    type="primary"
                                    onClick={toExport}
                                >
                                    Exportar
                                </Button>
                                {
                                    siteId === 'HUB' ?

                                        <Button
                                            className={classes.button}
                                            variant="contained"
                                            type="primary"
                                            onClick={() => {
                                                props.setTab("2");
                                            }}
                                        >
                                            Nuevo 
                                        </Button>
                                        : null
                                }
                                <Button
                                    className={classes.button}
                                    onClick={() => downloadTemplate()}
                                    type="primary"
                                    variant="contained"
                                    icon="file-excel"
                                    style={{ backgroundColor: '#288504', borderColor: "#288504" }} >
                                    Descargar Template
                                </Button>

                            </div>
                        </div>
                    )
                }}
            </WorkCycleTableContainer>
        </div>
    );
}